import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import OrderCard from './components/OrderCard';

export default function HistoryOrders() {
  const { t } = useTranslation();
  const localhost = process.env.REACT_APP_LOCALHOST;

  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(true);
  const [myOrders, setMyOrders] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(localhost + "completed-orders", { headers: { 'Authorization': `Bearer ${token}` } });
        setMyOrders(res.data);
      } catch (err) {
        // 
      }finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const subtotal = myOrders.reduce((acc, { total_amount }) => acc + parseFloat(total_amount), 0).toFixed(2);

  if (loading) {
    return (
      <div className="min-h-[55vh] flex items-center justify-center">
        <div className="loading-spinner" />
      </div>
    )
  }

  return (
    <div className="col-span-8 overflow-hidden rounded-xl sm:bg-gray-50">
      <h1 className="pt-2 text-xl text-black font-semibold">{t("purchases")}</h1>
      <p className="text-sm text-slate-600">{t("all-purchases")}</p>
      <hr className="mt-4 mb-6" />
      {
        myOrders.length > 0 ? (
          <section className="relative">
            <div className="w-full max-w-7xl mx-auto">
              <div className="w-full flex-col justify-start items-start gap-8 inline-flex">
                <div className="w-full justify-center items-start ">
                  {
                    myOrders.map((item, index) => (
                      <OrderCard key={index} data={item} />
                    ))
                  }
                </div>
                <div className="w-full p-5 rounded-xl border border-gray-200 flex-col justify-start items-center gap-4 flex">
                  <div className="w-full justify-between items-center gap-6 inline-flex">
                    <h5 className="text-black text-base font-normal leading-8">{t("subtotal")} :</h5>
                    <h5 className="text-right text-black text-2xl font-semibold leading-8">
                      {subtotal} <span className='text-xs leading-none pb-[1px]'>MAD</span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : <div className="flex items-center p-4 mb-4 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50" role="alert">
          <ExclamationCircleIcon className='flex-shrink-0 inline w-5 h-5 me-2' />
          <span className="sr-only">Info</span>
          <div className='flex flex-wrap gap-1'>
            {t("all-purchases-1")} <a href='/shop' className='underline'>{t("all-purchases-2")}</a>
          </div>
        </div>
      }
    </div>
  )
}